import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MapsService } from '../../../services/maps.service';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss']
})
export class JobDetailsComponent implements OnInit {


  latitude: number;
  longitude: number;
  isMapJob: boolean = false
  addressList = []
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _mapsService: MapsService,
  ) {
    this.dialogRef.disableClose = false
  }

  ngOnInit() {
    console.log("value of single job details", this.data)
    // if (this.data && this.data.jobType == 'trainer') 
    this.viewLocation(this.data)
    // if (this.data && this.data.jobType == 'labour') this.viewLabourjobLocation(this.data)
  }


  // UTILITY



  viewLocation(job) {
    let location
    if (this.data && (this.data.jobType == 'trainer' || this.data.jobType == 'mp')) location = job.clients[0].location
    if (this.data && this.data.jobType == 'labour') location = job.locationDetails._id
    if (location && location.address && location.address.length) {
      this.latitude = location.locationGeometry.coordinates[1]
      this.longitude = location.locationGeometry.coordinates[0]
      this.addressList = location.address
    } else {
      console.log("Here the job details for location", job, location);
      this._mapsService.getLocation(location.title).subscribe((locationData) => {
        console.log("This is the location details using address", locationData.lat(), locationData.lng());
        if (locationData == null) return locationData
        this.latitude = locationData.lat()
        this.longitude = locationData.lng()
      })
    }

  }

  // viewLabourjobLocation(job) {
  //   let location = job.locationDetails._id
  //   this.latitude = location.locationGeometry
  // }


  getSingleUser(event) {
    console.log("when click on single user here to close the model", event);
    this.dialogRef.close()
  }

}
